import * as Yup from "yup";
import { useRouter } from "../../../routes/hooks";
import { enqueueSnackbar } from "notistack";
import { IBranch } from "../../../types/branch";
import { useCallback, useEffect, useState } from "react";
import { IDepartment } from "../../../types/department";
import { useBoolean } from "../../../hooks/use-boolean";
import { AllBranchesService } from "../../../services/branches";
import { AllDepartmentsService } from "../../../services/departments";

const useUserUpdate = () => {

    const router = useRouter();
    const loading = useBoolean(true);

    const [branchs, setBranchs] = useState<IBranch[]>([]);
    const [departments, setDepartments] = useState<IDepartment[]>();

    const [selectedBranch, setSelectedBranch] = useState<IBranch | null>(null);
    const [selectedDepartment, setSelectedDepartment] = useState<IDepartment | null>(null);    

    const [currentTab, setCurrentTab] = useState('data');

    const handleChangeTab = useCallback((event: React.SyntheticEvent, newValue: string) => {
      setCurrentTab(newValue);
    }, []);

    const getData = async () => {

        loading.onTrue();

        await AllBranchesService().then(resp => {
            setBranchs(resp.data);
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

        await AllDepartmentsService().then(resp => {
            setDepartments(resp.data);
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

        loading.onFalse();

    }

    useEffect(() => {
        getData();
    }, []);

    return {
        loading,
        branchs,
        departments,
        selectedBranch,
        setSelectedBranch,        
        selectedDepartment,
        setSelectedDepartment,
        currentTab,
        handleChangeTab,
    }
}

export default useUserUpdate;